import { AlertCategory } from "../models/entities/alert-category.model";

/**
 * Fallback when alert categories API has not returned yet.
 * Used by useAlertCategories so the UI always has an array to iterate.
 */
export const DEFAULT_ALERT_CATEGORIES: AlertCategory[] = [];
